import './OrderDetails.css';
import {useState, useEffect} from 'react';

// const OrderDetails = ({productName, date, price, status})

const OrderDetails = ({productName, date, price, status}) => {

    const [orderStatus, setOrderStatus] = useState(null);

    function formatNumber(n, p, ts, dp) {
        var t = [];
        // Get arguments, set defaults
        if (typeof p == 'undefined') p = 2;
        if (typeof ts == 'undefined') ts = '.';
        if (typeof dp == 'undefined') dp = ',';

        // Get number and decimal part of n
        n = Number(n).toFixed(p).split('.');

        // Add thousands separator and decimal point (if requied):
        for (var iLen = n[0].length, i = iLen ? iLen % 3 || 3 : 0, j = 0; i <= iLen; i += 3) {
            t.push(n[0].substring(j, i));
            j = i;
        }
        // Insert separators and return result
        return t.join(ts) + (n[1] ? dp + n[1] : '');
    }

    const months = ["Januari", 
        "Februari", 
        "Maret", 
        "April", 
        "Mei", 
        "Juni", 
        "Juli",
        "Agustus",
        "September",
        "Oktober",
        "November",
        "Desember"
    ]

    const formateDate = (epochDate) => {
        let date = new Date(epochDate);
        let hours = date.getHours();
        let minutes = date.getMinutes().toString().length === 1 ? "0"+date.getMinutes() : date.getMinutes();
        let month = date.getMonth();

        return `${hours}:${minutes} ${date.getDate()} ${months[month]}, ${date.getFullYear()}`;
    }

    const getOrderStatus = async () => {
        const response = await fetch("https://payment-gateway-iai.herokuapp.com/api/transaction/status/"+status, {
            method: "GET"
        }).then(res => res.json())
        .then(data => {
            console.log(data.status)
            setOrderStatus(data.status)    
        });
    }
    
    useEffect(() => {
        getOrderStatus();
    }, [])

    let classNames = "orderdetails-status ";

    return (
        <tr>
            <td className="orderdetails-productname">{productName}</td>
            <td className="orderdetails-orderdate">{formateDate(date)}</td>
            <td className="orderdetails-amount">1</td>
            <td className="orderdetails-price">{formatNumber(price, 0)}</td>
            {
                orderStatus == "true" ? 
                <td className={classNames += "paid-status"}>Dibayar</td>
                :
                <td className={classNames += "not-paid-status"}>Belum dibayar</td>
            }
            
        </tr>
    )
}

export default OrderDetails;